// extracted by mini-css-extract-plugin
export default {"cpvCodesContainer":"ZeKZHoQLpzdRkvEew8bV__cpvCodesContainer___","cpvCodesNote":"ffSRW85Tly6XT6CWU2L5__cpvCodesNote___","settingsLabel":"GOvGflFAiHQPVsdEGM2O__settingsLabel___"};